import { Expose, Type } from 'class-transformer';
import { BaseEntity } from './base.entity';
import { InstallationEntity } from './installation.entity';

export class InstallationListEntity extends BaseEntity {
  @Expose()
  @Type(() => InstallationEntity)
  public installations: InstallationEntity[];
}
